// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader___uQaJ","loaderOuter":"PageOverlayLoader_loaderOuter__2GTdb"};